export const TripsPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Trips Management</h1>
        <p className="mt-1 text-sm text-gray-500">
          View and manage user trips and travel data.
        </p>
      </div>
      
      <div className="bg-white shadow rounded-lg p-6">
        <p className="text-gray-500">Trips management coming soon...</p>
      </div>
    </div>
  )
} 